import React from 'react';
import { ChevronRight } from 'lucide-react';

const TEMPLATES = ['Invitation email', 'Reminder email', 'Completion email', 'Rejection email'];

export default function EmailTemplatesTab() {
  return (
    <div>
      <h2 className="text-[18px] font-bold text-[#1A1533]">Email templates</h2>
      <p className="text-[13px] text-[#4A4463] mt-2">Customize the emails sent to candidates at different stages.</p>
      <div className="mt-5 space-y-2">
        {TEMPLATES.map((t) => (
          <button key={t} className="w-full flex items-center justify-between px-4 py-3 rounded-xl border border-[#ECE6FA] bg-white hover:bg-[#FAF8FF]">
            <span className="text-[13.5px] font-semibold text-[#1A1533]">{t}</span>
            <ChevronRight size={14} className="text-[#8A83A5]" />
          </button>
        ))}
      </div>
    </div>
  );
}

export function JobsTab() {
  return (
    <div>
      <h2 className="text-[18px] font-bold text-[#1A1533]">Jobs</h2>
      <p className="text-[13px] text-[#4A4463] mt-2">Configure job board and default application settings.</p>
      <div className="mt-5 rounded-xl border border-dashed border-[#C7BFF5] bg-[#FAF8FF] p-6 text-center">
        <p className="text-[13px] text-[#4A4463]">Jobs synced from Frappe HR will appear here.</p>
      </div>
    </div>
  );
}
